import { Outlet } from "react-router";

type Props = {}

const Program = (props: Props) => {
    return <Outlet />
};
export default Program 